import { useCallback } from 'react';
import { saveForUserContextEncrypted, saveForUserContextUnencrypted } from '@famly/stat_ts-utils_local-storage';
/**
 * Writes a value to the user-context local storage that `useStatLocalStorage` reads. Use it instead of
 * assigning to `useStatLocalStorage`'s result, which makes the React Compiler skip the component.
 */
export const useSetStatLocalStorage = (options) => {
    var _a;
    const encrypted = (_a = options === null || options === void 0 ? void 0 : options.encrypted) !== null && _a !== void 0 ? _a : true;
    // Callers outside the compiled roots (Jest, the coverage build) list the setter in deps, so it has
    // to be stable without the compiler's help.
    return useCallback((key, value) => encrypted ? saveForUserContextEncrypted(key, value) : saveForUserContextUnencrypted(key, value), [encrypted]);
};
